export default __webpack_public_path__ + "static/media/Teremsefi's Design.0f98cc6a.jpg";